// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3nNN6","visuallyhidden":"_3Q_ZL","hide-text":"_3buMJ","center":"_PpTZ","noprint":"_17UFB","subsections":"_-U2wv","sectionLinks":"_2eiTa","subsectionsContainer":"_2x2Xk","subsectionsContainer-isOpen":"MGRKN _2x2Xk","subsectionItem":"_3JkWs","subsectionLink":"vkx6Z","dropdownTrigger":"_3ZhjJ","dropdownTrigger-isOpen":"c9jBi _3ZhjJ","sectionLabel":"_1ZJmQ","sectionLabelContainer":"Pu8WX","active":"_13OmY"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/MastheadExtensionSectionView.scss
 ** module id = 966
 ** module chunks = 1
 **/